import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Companies from './pages/Companies';
import './App.css';
import Topbar from "./components/Topbar";
import CourierList from "./pages/CourierList";
import CourierDetail from "./pages/CourierDetail";
import CargoDetail from './pages/CargoDetail';



function App() {
  return (
    <Router>
      <div className="App">
        <Topbar />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/courierlist" element={<CourierList />} />
            <Route path="/courier/:id" element={<CourierDetail />} />
            <Route path="/cargo/:id" element={<CargoDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
